module.exports = __webpack_public_path__ + "media/icons/x-circle-7a6cbec3.svg";